import styled                      from 'styled-components/macro'
import { useEffect, forwardRef }   from 'react'
import { useAtom, useGet } from 'state/jotai'
import { isIsoAnimationActive, isIsoBtnClick, rotate_by_slider } from 'state/store.global'
import { useWindowSize } from 'hooks/useWindowResize'

export const Canvas = forwardRef(({dim,frames,frame,pid,status,config, stopframes},ref ) => {
  if (!frames || frames.length === 0) return null;

  const setIsoAnimationActive             = useAtom(isIsoAnimationActive)[1];
  const [isoBtnClick, setIsoBtnClick] = useAtom(isIsoBtnClick)
  const isIsometryRotate = useGet(rotate_by_slider)
  const size = useWindowSize()
  
  useEffect(() => {
    const ctx = ref?.current?.getContext("2d");
    if (!ctx) return;

    const w = dim.W;
    const h = dim.H;

    const i = frames.findIndex((i) => Object.keys(i)[0] == frame);
    const img = frames?.[i]?.[frame];

    if (!img?.src) return;
    
    ctx.canvas.width = w;
    ctx.canvas.height = h;
    ctx.clearRect(0, 0, w, h);
    ctx.globalAlpha = 1; // Full opacity
    
    if (!img?.complete || img?.naturalWidth === 0) {
      console.warn("Image not fully loaded, retrying...");
      img.onload = () => {
        ctx.drawImage(img, 0, 0, w, h);
      };
      return;
    }
 
    ctx.drawImage(img, 0, 0, w, h);
    const snapIndex = config.IMAGE_SNAPFRAMES.indexOf(frame);

    if (config.IS_STOP_RENDER && snapIndex > -1 && stopframes) {
    
      const i = stopframes.findIndex((i) => Object.keys(i)[0] == config.STOP_IMAGE_SNAPFRAMES[snapIndex]);

      let debounceTimer1
      let animationFrameId1

        const debouncedAnimation = () => {
          clearTimeout(debounceTimer1); // Clear the previous debounce timer
          debounceTimer1 = setTimeout(() => {
            setIsoAnimationActive(true)
            const stopImg = stopframes?.[i]?.[config.STOP_IMAGE_SNAPFRAMES[snapIndex]];

            if (!stopImg?.src) return;
  
            let opacityNormal = 1; // Start fully visible
            let opacityStop = 0;
  
            const startAnimation = () => {
              if (opacityStop < 1) {
                opacityNormal = Math.max(0, opacityNormal - 0.010); // Ensure it never goes below 0
                opacityStop = Math.min(1, opacityStop + 0.040); // Ensure it never exceeds 1
  
                ctx.clearRect(0, 0, w, h);
  
                // Draw normal image first
                ctx.globalAlpha = opacityNormal;
                ctx.drawImage(img, 0, 0, w, h);
  
                // Draw stop image second (on top)
                ctx.globalAlpha = opacityStop;
                ctx.drawImage(stopImg, 0, 0, w, h);
  
                animationFrameId1 = requestAnimationFrame(startAnimation);
              } else {
                // Ensure the stop image remains fully visible after animation
                ctx.clearRect(0, 0, w, h);
                ctx.globalAlpha = 1;
                ctx.drawImage(stopImg, 0, 0, w, h);

                setIsoAnimationActive(false)
              }
            };
  
            startAnimation();
          }, 500); // Debounce timeout of 300ms
        };
  
        debouncedAnimation();

      return () => {
        clearTimeout(debounceTimer1); // Clear debounce timer
        cancelAnimationFrame(animationFrameId1); // Cancel ongoing animation frame   
      };
    }
  }, [size, frame, pid, status, dim.W, dim.H]);

  useEffect(()=> {

    const ctx = ref?.current?.getContext("2d");
    if (!ctx) return;

    const w = dim.W;
    const h = dim.H;

    const i = frames.findIndex((i) => Object.keys(i)[0] == frame);
    const img = frames?.[i]?.[frame];

    
    const snapIndex = config.IMAGE_SNAPFRAMES.indexOf(frame);


    if (config.IS_STOP_RENDER && snapIndex > -1 && stopframes) {
 

      const i = stopframes.findIndex((i) => Object.keys(i)[0] == config.STOP_IMAGE_SNAPFRAMES[snapIndex]);

      let debounceTimer2
      let animationFrameId2
   
      if(isoBtnClick) {
        // setIsoAnimationActive(true)
        const debouncedAnimation = () => {
          clearTimeout(debounceTimer2); // Clear the previous debounce timer
     
          debounceTimer2 = setTimeout(() => {
            const stopImg = stopframes?.[i]?.[config.STOP_IMAGE_SNAPFRAMES[snapIndex]];
        
            if (!stopImg?.src) return;
  
            let opacityNormal = 1; // Start fully visible
            let opacityStop = 0;
          
            const startAnimation = () => {
              if (opacityStop < 1 || opacityNormal > 1) {
                opacityNormal = Math.max(0, opacityNormal - 0.4); // Ensure it never goes below 0
                opacityStop = Math.min(1, opacityStop + 0.5); // Ensure it never exceeds 1
  
                ctx.clearRect(0, 0, w, h);
  
                // Draw normal image first
                ctx.globalAlpha = opacityNormal;
                ctx.drawImage(stopImg, 0, 0, w, h);
  
                // Draw stop image second (on top)
                ctx.globalAlpha = opacityStop;
                ctx.drawImage(img, 0, 0, w, h);
  
                animationFrameId2 = requestAnimationFrame(startAnimation);
              } else {
                // Ensure the stop image remains fully visible after animation
                ctx.clearRect(0, 0, w, h);
                ctx.globalAlpha = 1;
                ctx.drawImage(img, 0, 0, w, h);
              }
            };
  
            startAnimation();
          }, 100)
        };
  
        debouncedAnimation();
      }

      return () => {
        cancelAnimationFrame(animationFrameId2); // Cancel ongoing animation frame
        clearTimeout(debounceTimer2); // Clear debounce timer
      };
    }

  }, [isoBtnClick])


  const ready = frames?.[config?.IMAGE_NUM-1]?.[config?.LAST_IMAGE]?.src


  return ( 
    <> 
      { ready &&
        <StyledCanvas 
          w={dim.W} 
          h={dim.H} 
          ref={ref}
          isIsometryRotate={isIsometryRotate}
          />
      } 
    </> 
  )

})

const StyledCanvas = styled.canvas`
  width: ${x => x.w}px;
  height: ${x => x.h}px;
  max-width: unset;
  background: transparent;
  position: absolute;
  // filter: ${x => !x.isIsometryRotate && 'blur(3px)'}
`


 